import { render, staticRenderFns } from "./AddCustomers.vue?vue&type=template&id=09257688&scoped=true&"
import script from "./AddCustomers.vue?vue&type=script&lang=js&"
export * from "./AddCustomers.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomers.vue?vue&type=style&index=0&id=09257688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09257688",
  null
  
)

export default component.exports